import CreateLeague from '../CreateLeague.vue'
import CreateLeagueStep2 from "@/modules/create-league/components/step-2/Step2.vue";
import CreateLeagueStep1 from "@/modules/create-league/components/step-1/Step1.vue";
import CreateLeagueStep4 from "@/modules/create-league/components/step-4/Step4.vue";
import CreateLeagueStep3 from "@/modules/create-league/components/step-3/Step3.vue";

export default [
    {
        path: '/create-league',
        name: 'CreateLeague',
        component: CreateLeague,
        meta: { requiresNavbar: true },
        children: [
            {
                path: '/create-league',
                name: 'Create League',
                component: CreateLeagueStep1,
                meta: { requiresNavbar: true, step: 1 },
            },
            {
                path: '/create-league/step2',
                name: 'CreateLeagueStep2',
                component: CreateLeagueStep2,
                meta: { requiresNavbar: true, step: 2 },
            },
            {
                path: '/create-league/step3',
                name: 'CreateLeagueStep3',
                component: CreateLeagueStep3,
                meta: { requiresNavbar: true, step: 3 },
            },
            {
                path: '/create-league/step4',
                name: 'CreateLeagueStep4',
                component: CreateLeagueStep4,
                meta: { requiresNavbar: true, step: 4 },
            },
        ],
    },
];
